import DevicesManager from "./DevicesManager";
import VideoManager from "./VideoManager";

/**
 * Менеджер видео-конференции
 */
export default class ConferenceManager {
    public devicesManager: DevicesManager;
    public videoManager: VideoManager;

    constructor()
    {
        this.devicesManager = new DevicesManager();
        this.videoManager = new VideoManager();

        this.setManagers();
    }

    /**
     * Изменение провайдера конференции
     */
    public changeProvider(provider: string): void
    {
        this.devicesManager.changeProvider(provider);
        this.videoManager.changeProvider(provider);

        this.setManagers();
    }

    /**
     * Установка управляющих классов видео-конференции
     * @private
     */
    private setManagers(): void
    {
        const videoProvider = this.videoManager.getProvider();
        const devicesProvider = this.devicesManager.getProvider();

        videoProvider.setDevicesManager(devicesProvider);
        devicesProvider.setVideoManager(videoProvider);
    }
}
